import Relay from 'react-relay/classic';
import RelayGraphQLMutation from 'react-relay/lib/RelayGraphQLMutation.js';
import moment from 'moment';

export default class UpdateSCORMMutation {
  constructor(props) {
    this.props = props;
  }

  updateScormPayload = Relay.QL`
    fragment on updateScormPayload {
      course {
        coursePerformance {
          visibleCompleted
          timeSpent
          scaledProgressMeasure
          completionStatus
          successStatus
        }
      }
      card {
        performance {
          completionStatus
          successStatus
          scaledScore
          rawScore
          progressMeasure
          scaledProgressMeasure
          reAttemptCount
          scorm {
            mastery_score
            scormData
          }
        }
      }
    }
  `;

  commit(callbacks) {
    const query = Relay.QL`
      mutation UpdateSCORMMutation($input_0: updateScormInput!) {
        updateScorm(input: $input) {
          ${this.updateScormPayload}
          clientMutationId
        }
      }
    `;
    const variables = {
      userId: this.props.userId,
      input: {
        offerId: this.props.courseId,
        cardId: this.props.cardId,
        userId: this.props.userId,
        timeStamp: moment().toISOString(),
        reAttemptCount: this.props.reAttemptCount,
        // pathId: this.props.pathId,
        scormData: JSON.stringify({
          lesson_location: this.props.lesson_location,
          credit: this.props.credit,
          entry: this.props.entry,
          lesson_status: this.props.lesson_status,
          total_time: this.props.total_time,
          suspend_data: this.props.suspend_data,
          exit: this.props.exit,
          session_time: this.props.session_time,
          interactions: this.props.interactions,
          progress_measure: this.props.progress_measure,
          score_raw: this.props.score_raw
        })
      }
    };
    const mutation = new RelayGraphQLMutation(query, variables, null, Relay.Store, callbacks);

    const config = [{ type: 'FIELDS_CHANGE' }];
    // console.log('add time mutation: ', this.props);
    config[0].fieldIDs = {
      card: this.props.cardMainId,
      course: this.props.courseMainId
    };

    // isAssigned && console.log('apply optimistic finish', optimisticResponse);
    // console.log(mutation);
    mutation.commit(config);
  }
}
